.alt-palette {
	height: 100%;
	padding: 10px 0;
	box-sizing: border-box;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-evenly;
}
